import { number } from "@intlify/core-base"

export const translatedPath = (full_slug: string):string => {
	//const localePath = useLocalePath()
	if(!full_slug) return ''
	const segments = full_slug.split('/')
	return segments[segments.length-1] as string
	//return localePath('/blog')+`?category=${full_slug.replace(`${item.lang}/`,'').replace('categories/','')}`
}

interface Dimension {
	width: number
	height: number
}

export const imageDimension = (url: string):Dimension => {
	const size = url.split('/')[5].split('x')
	return {
		width: Number.parseInt(size[0]),
		height: Number.parseInt(size[1])
	}
}

export const imageType = (url: string):string => {
	const parts = url.split('.')
	return parts[parts.length-1] as string
}